<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        parseInt(item.description) >= 0 &&
          parseInt(item.description) <= 3 &&
          'color-green',
        parseInt(item.description) >= 4 &&
          parseInt(item.description) <= 7 &&
          'color-orange',
        parseInt(item.description) >= 8 &&
          parseInt(item.description) <= 10 &&
          'color-red',
      ]"
    >
      {{ handleDescriptionAche(item.description) }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Dor",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
  methods: {
    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },
  },
};
</script>